import React from 'react';

import {calculateOnTrack} from 'shared/utils';
import {useMediaQuery} from 'src/hooks/useMediaQuery';

import InProgressBar from '../in-progress-bar';
import InProgressGauge from '../in-progress-gauge';
import SuccessMessage from '../success-message';
import {PartialStudent} from '../on-track';

interface Props {
  student: PartialStudent;
  onTrack: {
    onTrack: boolean;
  };
}

const Display = ({
  student: {
    firstName,
    highSchoolInfo: {graduationYear, senior},
    totalCredits,
  },
  onTrack,
}: Props) => {
  const mq = useMediaQuery();
  const gaugeInfo = calculateOnTrack(totalCredits, graduationYear);
  const color = senior && gaugeInfo.totalCredits < gaugeInfo.goalCredits ? 'red' : 'blue';
  let activeComponent: React.ReactNode = null;

  if (!gaugeInfo.finished) {
    activeComponent = mq.SM_AND_UP ? (
      <InProgressBar gaugeInfo={gaugeInfo} color={color} />
    ) : (
      <InProgressGauge gaugeInfo={gaugeInfo} color={color} />
    );
  }

  if (!onTrack.onTrack && gaugeInfo.finished) {
    activeComponent = <SuccessMessage name={firstName} />;
  }

  return activeComponent;
};

export default Display;
